import template from './bot-sessions.html';
import controller from './bot-sessions.controller';
import './bot-sessions.styl';

let botSessionsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default botSessionsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-sessions/bot-sessions.component.js
 **/